<div class="flex" #palabra>
  <svg class="icon-draggable" #iconSvg>
    <use xlink:href="#icon-draggable" #iconUse></use>
  </svg>
  <span>{{palabraClave.nombre}}</span>
</div>
